import { render, staticRenderFns } from "./getShelfTransStatus.vue?vue&type=template&id=14cb8696&"
import script from "./getShelfTransStatus.vue?vue&type=script&lang=js&"
export * from "./getShelfTransStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports